import React, { Component } from 'react';
// import { List, ListItemText } from 'appkit-react';
// import { Tooltip } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { BreadCrumb } from '@components';
import actions from '@flux/action';
import ReportIssue from './reportIssue';
import ProjectSettingDirect from './projectSettingDirect';
// import GlobalSearch from './globalSearch';
// import '@style/components/weeklyReport.scss';
import '../styles/components/weeklyReport.scss';
import ProjectUsers from 'src/ddvComment/projectUsers';
import CommentCenter from 'src/ddvComment/CommentCenter';
import NotificationCenter from 'src/ddvComment/NotificationCenter/NotificationCenter';
// import { UserAvatar } from '@components/commonAvatar';
import NameInitialsDropdown from '@components/nameInitialsDropdown';
import { projectRole } from '@model';
// import ProjectUsers from './projectUsers.js';
class AppHeader extends Component {
  // constructor(props, context) {
  //   super(props, context);
  //   this.state = {
  //     isTooltipVisible: false,
  //     isShow: false,
  //     showWeeklyReport: false,
  //   };
  //   this.handleSignOut = this.handleSignOut.bind(this);
  //   this.jumpAndCloseTooltip = this.jumpAndCloseTooltip.bind(this);
  // }
  // componentDidMount() {
  //   this.props.history.listen((e) => {
  //     this.setState({ isTooltipVisible: false });
  //   });
  //
  //   document.addEventListener('click', (e) => {
  //     this.setState({
  //       isTooltipVisible: false,
  //     });
  //   });
  // }
  // static getDerivedStateFromProps(props, state) {
  //   // const nameLabel = given_name[0] + family_name[0];
  //   return {
  //     ...state,
  //     // nameLabel: nameLabel.toUpperCase(),
  //     userInfo: props.userInfo,
  //   };
  // }

  // jumpAndCloseTooltip(path) {
  //   const currentPath = this.props.history.location.pathname;
  //   const namesInitialsPaths = [
  //     '/settings',
  //     '/guide',
  //     '/guide-shared',
  //     '/issue-list',
  //     '/privacy',
  //   ];
  //   const pathsNeedBackToProjectHome = [
  //     '/projects/manageTiles',
  //     '/projects/imageLink',
  //     '/projects/link',
  //     '/projects/powerBI',
  //     '/powerBI',
  //     '/link',
  //     ...namesInitialsPaths,
  //   ];
  //   const pathNeedBackToProjectList = ['/projects/list', ...namesInitialsPaths];
  //   if (currentPath !== path) {
  //     const currentProjectId = getSessionStorage('currentId');
  //     const needBackToProjectHome =
  //       currentProjectId &&
  //       pathsNeedBackToProjectHome.some((i) => currentPath.startsWith(i));
  //     const needBackToProjectList =
  //       !currentProjectId &&
  //       pathNeedBackToProjectList.some((i) => currentPath.startsWith(i));
  //     let from = {};
  //     if (needBackToProjectHome) {
  //       from = {
  //         path: `/project-detail/${currentProjectId}`,
  //         state: { preventRefresh: true },
  //       };
  //     } else if (needBackToProjectList) {
  //       from = {
  //         path: '/projects/list',
  //         state: {},
  //       };
  //     } else {
  //       from = {
  //         path: currentPath,
  //         state: {},
  //       };
  //     }
  //     this.props.history.push({
  //       pathname: path,
  //       state: { from },
  //     });
  //   }
  //   this.setState({
  //     isTooltipVisible: false,
  //   });
  // }

  render() {
    const isloggedIn = window.localStorage.getItem('accessToken')
      ? true
      : false;
    const {
      // userInfo = {},
      popReportIssue,
      projectId,
      currentUserPermission,
      projectInfo: { projectName = 'Current Project' } = {},
      location,
    } = this.props;

    const isLoginPage = location?.pathname === '/login';

    return (
      <div className="app-header">
        <div className="title">
          {isLoginPage ? (
            <span className="login-header-title">M&A Gateway</span>
          ) : (
            <BreadCrumb />
          )}
        </div>
        <ReportIssue />
        <div className="avatar-wrapper">
          {projectId && <ProjectUsers />}
          {isloggedIn ? (
            <div className="report-issue" onClick={popReportIssue}>
              Report Issue
            </div>
          ) : (
            ''
          )}

          {projectId && currentUserPermission === projectRole.Contributor && (
            <ProjectSettingDirect
              projectId={projectId}
              projectName={projectName}
            />
          )}
          {projectId && <CommentCenter projectId={projectId} />}

          {projectId && <NotificationCenter />}

          {/* {projectId && <GlobalSearch projectName={projectName} />} */}
          {/* <Badge count={99} offset={[-16, 5]}>
            <span className="appkiticon icon-notification-outline"></span>
          </Badge> */}
          <NameInitialsDropdown />
        </div>
      </div>
    );
  }
}

AppHeader.defaultProps = {
  basePath: '',
  history: {},
  label: '',
};

const mapStateToProps = ({ login, common, projects }) => ({
  userInfo: login.userInfo,
  projectId: common.currentId,
  projectInfo: projects.projectDetail?.projectInfo || {},
  currentUserPermission: common.projectCompanyInfo?.currentUserPermission,
});

const mapDispatchToProps = (dispatch) => ({
  popReportIssue: (defaultValues) => {
    dispatch(actions.popReportIssueModal(defaultValues));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(AppHeader));
